import type { InputType } from './Input.types';

export const mapInputType = (type: InputType) => {
  switch (type) {
    case 'email':
      return 'email';
    case 'phone':
      return 'phone';
    case 'identityNumber':
    case 'text':
      return 'text';
  }
};
